export interface OverflowEllipsisProps {
  ellipsisPlacement?: EllipsisPlacement;
}

export enum EllipsisPlacement {
  BEGINNING,
  END,
}
